import React, { useState, useContext, useEffect } from 'react';
import styled from 'styled-components';
import { ButtonYellow } from '../../_elements';
import { Spinner } from '../../_helpers/constants';
import { AuthContext } from '~/_context';

const WrapperStyled = styled.div`
  display: flex;
  flex: 1;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  /*background-color: #F5F6FA;*/
  .text_top{
    width: 100%;
    text-align: left;
    margin-bottom: 15px;
  }
  .errorMessagesCode{
      display: flex;
      flex-direction: row;
      width: 100%;
      margin-bottom: 10px;
      margin-top: 10px;
      p{
        font-size: 14px;
        line-height: 16px;
        color: #F20000;
        padding: 0 0 0 2px;
        margin: 0;
      };
    }
`
const Field = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  &.field_password{
    margin-top: 15px;
    position: relative;
    .password_show{
      width: 50px;
      right: 0;
      bottom: 0;
      text-align: center;
      position: absolute;
      font-size: 30px;
      line-height: 41px;
      padding-bottom: 1px;
      cursor: pointer;
      :hover{
        color: #FFD200;
      }
    }
  }
`
const Label = styled.label`
  display: flex;
  width: 100%;
  margin-bottom: 3px;
  color: #242424;
`
const Input = styled.input`
  width: 100%;
  padding-top: 6px;
  padding-bottom: 6px;
  padding-left: 10px;
  padding-right: 10px;
  font-size: 18px;
  border: 1px solid #edeef0;
  ::placeholder {
    color: #a8a8a8;
    font-size: 16px;
  }
  :focus{
    outline: none;
  }
  *:focus {
    outline: none;
  }
  &.error{
    border: 1px solid red!important;
  }
`
const Actions = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  .loader{
    margin-top: 15px!important;
    height: 40px;
  }
  .bt_login,
  .bt_cancel{
    margin-bottom: 10px;
  }
  .bt_login,
  .bt_cancel,
  .bt_resend{
    text-transform: capitalize!important;
  }
  .bt_resend{
    cursor: pointer!important;
    background-color: #FFD200!important;
    p{
        color: #000000!important;
    }
    &.disabled{
        cursor: default!important;
        background-color: transparent!important;
        p{
            color: #FFD200!important;
        }
    }
    :hover{
        background-color: transparent!important;
        p{
            color: #FFD200!important;
        }
    }
  }
  .bt_cancel{
    background-color: #E02020!important;
    border: 1px solid #E02020;
    p{
        color: #FFFFFF;
    }
    :hover{
        background-color: #FFFFFF!important;
        border: 1px solid #E02020!important;
        p{
            color: #E02020!important;
        }
    }
  }
`
const ErrorMessage = styled.div`
  display: flex;
  width: 100%;
  margin-top: 3px;
  p{
    color: #E02020;
    width: 100%;
    font-size: 14px;
    text-align: right;
  }
`

const Mfa = () => {

    const { session,
            mfaData,
            isMfaLoading, 
            setIsMfaLoading,
            codeDeliveryDestination,
            respondToMfaChallenge,
            resendMfaCode,
            showMfa,
            setShowMfa,
            setShowLogin } = useContext(AuthContext);

    const [ code, setCode ] = useState("");
    const [ errorFields, setErrorFields ] = useState({code: false});
    const [ errorCodeMessage, setErrorCodeMessage ] = useState("");

    const handleFormSubmit = () => {
    }

    const [countdown, setCountdown] = useState(60);

    useEffect(() => {
        if (countdown > 0) {
            const timer = setTimeout(() => setCountdown(countdown - 1), 1000);
            return () => clearTimeout(timer);
        }
    }, [countdown]);

    const handleSendCode = () => {
        const response = respondToMfaChallenge(code, mfaData, session);
        response.then(res_challenge => {
            //console.log("res_challenge", res_challenge)
        }).catch(err => {
            setErrorCodeMessage("Hubo un error con el código ingresado, intentalo nuevamente.");
            setIsMfaLoading(false);
            //console.error("Error responding to MFA challenge:", err);
            setErrorFields({code: true});
        })
    }
    const handleResendCode = () => {
        setCode("");
        resendMfaCode(mfaData, session);
    }

    const handleCancel = () => {
        setCode("");
        setCountdown(60);
        setShowMfa(false);
        setShowLogin(true);
        setErrorFields({code: false});
    }

    return (
        <WrapperStyled>
            <div className='text_top'>
                Para continuar por favor ingresá el código que te enviamos a: {codeDeliveryDestination}
            </div>
            <Field>
                <Label>Código de confirmación:</Label>
                <Input
                    type="text"
                    placeholder="Ingresá el código de confirmación..."
                    value={code}
                    className={errorFields.code ? 'error' : '' }
                    onChange={(e) => setCode(e.target.value)}
                />
            </Field>

            {errorCodeMessage.length ? 
              <div className='errorMessagesCode'>
                <p>{errorCodeMessage}</p> 
              </div>
            : ""}

          <Actions>

            {isMfaLoading ?
            <Spinner className="loader" />
            :
            <>
            <ButtonYellow className="bt_login" onClick={handleSendCode}>
              <p>VALIDAR CÓDIGO</p>
            </ButtonYellow>
            <ButtonYellow className="bt_cancel" onClick={handleCancel}>
              <p>CANCELAR</p>
            </ButtonYellow>
            <ButtonYellow 
                className={`bt_resend ${countdown ? 'disabled' : ''}`} 
                onClick={!countdown ? handleResendCode : null}
                //disabled={!countdown ? true : false}
            >
              <p>REENVIAR  {countdown ? 'EN '+countdown+'s' : 'CÓDIGO'}</p>
            </ButtonYellow>
            </>
            }

          </Actions>
        </WrapperStyled>
    );
};

export default Mfa;